import BasicCalls from '@/api/models/BasicCalls'

class Options extends BasicCalls {
    constructor() {
        super()
        this.apiRoot = 'frontend-api'
        this.apiVersion = 'public'
        this.apiBase = 'options'
    }

    getOptions(type, query) {
        return this.fetch(type, query)
    }
}

export { Options }
